import React from "react";
import { faRightLeft } from "@fortawesome/free-solid-svg-icons";
import useTranslation from "../../../hooks/useTranslation";
import { ToolbarPillButton } from "./Toolbar";
import { ViewerEngine } from "./useViewerEngine";

interface Props {
    engine: ViewerEngine;
    onToggle: () => void;
}

export default function EngineToggle({ engine, onToggle }: Props) {
    const { t } = useTranslation();
    const isEmbed = engine === "embedpdf";

    return (
        <ToolbarPillButton
            icon={faRightLeft}
            title={
                isEmbed
                    ? t("pdf_viewer.engine.switch_to_classic")
                    : t("pdf_viewer.engine.switch_to_new")
            }
            onClick={onToggle}
            variant={isEmbed ? "accent" : "default"}
        />
    );
}
